import React from 'react'

import ActionCardTemplate from '@f/elements/ActionCardTemplate/ActionCardTemplate'
import { BarTile } from '@f/elements/BarTile/BarTile'
import Icon from '@f/elements/Icon'

import { Nullable } from '@f-fertighaus/applications/Next/types/utility'
import { $TSFixMe } from '@f-fertighaus/applications/UserAccount/interfaces/utils'

export interface RadioStepOption<T = string | number> {
  value: T
  icon?: string | (() => JSX.Element)
  label: string | React.ReactNode
  custom_checkout_content_id?: string
  inputProps?: Partial<HTMLInputElement>
  image?: Nullable<{
    src: string
    alt: string
  }>
  onClick?: () => void
}

export const composeTileOptions = (tileStyle: 'card' | 'bar') =>
  tileStyle === 'card' ? composeCardTileOptions : composeBarTileOptions

const composeCardTileOptions = (options: RadioStepOption[]) => {
  return options.map(({ icon, ...option }) => ({
    ...option,
    ...{
      CardIcon: () => {
        if (typeof icon === 'string') {
          return (
            <Icon
              icon={icon}
              className={`[ f-icon-100 ${
                /-fill/.test(icon) ? 'f-c-fi-pri' : 'f-c-st-pri'
              } ]`}
            />
          )
        }
        const Component = icon
        return <Component />
      }
    },
    labelClassName: 'f-t-bold f-p-h-010',
    imageWrapperClassName: 'ActionCardTemplate-holder--stretched',
    ItemTemplate: (radio: $TSFixMe) => (
      <div {...(option.onClick && { onClick: option.onClick })}>
        <ActionCardTemplate sizeActionCard='large' {...radio} />
      </div>
    )
  }))
}

const composeBarTileOptions = (options: RadioStepOption[]) => {
  return options.map(option => ({
    ...option,
    ItemTemplate: ({
      label,
      onClick
    }: {
      label: string
      onClick: () => void
    }) => <BarTile label={label} onClick={onClick} />
  }))
}
